import './ExpressionParser.svelte.css';
/* src/components/ExpressionParser.svelte generated by Svelte v3.57.0 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_input_value,
	space,
	text,
	toggle_class
} from "../../_snowpack/pkg/svelte/internal.js";

import { expressionStore, userStore } from "./stores.js";
import { errorCodes } from "../services/parsingErrors.js";
import { parseUserInput, getErrorsFromParsing } from "../services/parseUserInput.js";

import {
	removeLocalization,
	addLocalization
} from "../services/localizeExpressions.js";

function create_fragment(ctx) {
	let div;
	let input;
	let t0;
	let small;
	let t1;
	let mounted;
	let dispose;

	return {
		c() {
			div = element("div");
			input = element("input");
			t0 = space();
			small = element("small");
			t1 = text(/*error*/ ctx[2]);
			attr(input, "type", "text");
			attr(input, "placeholder", "Insira uma fórmula. Ex: A = B + C");
			attr(input, "class", "svelte-17acmef");
			toggle_class(input, "unsaved", /*unsaved*/ ctx[1]);
			attr(small, "class", "error svelte-17acmef");
			attr(div, "class", "container");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, input);
			set_input_value(input, /*rawInput*/ ctx[0]);
			append(div, t0);
			append(div, small);
			append(small, t1);

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler*/ ctx[8]),
					listen(input, "keypress", /*parseIfIsEnter*/ ctx[3])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*rawInput*/ 1 && input.value !== /*rawInput*/ ctx[0]) {
				set_input_value(input, /*rawInput*/ ctx[0]);
			}

			if (dirty & /*unsaved*/ 2) {
				toggle_class(input, "unsaved", /*unsaved*/ ctx[1]);
			}

			if (dirty & /*error*/ 4) set_data(t1, /*error*/ ctx[2]);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $userStore;
	component_subscribe($$self, userStore, $$value => $$invalidate(7, $userStore = $$value));
	let { clearOnFinish = false } = $$props;
	let { current } = $$props;

	let rawInput = current
	? addLocalization(current.stringified, $userStore)
	: "";

	let unsaved = false;
	let lastStringified = rawInput;
	let error = "";

	function parseIfIsEnter({ key }) {
		// FIXME: mathjs is case-insensitive
		const trimmedInput = rawInput.trim();

		if (current) {
			$$invalidate(1, unsaved = true);
		}

		if (key !== "Enter" || trimmedInput.length === 0) {
			return;
		}

		const strippedLocalization = removeLocalization(trimmedInput, $userStore);
		$$invalidate(2, error = '');
		const codes = getErrorsFromParsing(strippedLocalization);

		if (codes.length > 0) {
			// TODO: Flash input to show error
			$$invalidate(2, error = codes.map(errorCodeToMessage).join());

			return;
		}

		const parsedResult = parseUserInput(strippedLocalization);
		expressionStore.addOrUpdate(parsedResult);
		$$invalidate(1, unsaved = false);

		if (clearOnFinish) {
			$$invalidate(0, rawInput = "");
		}
	}

	function errorCodeToMessage(code) {
		const messageByCode = {
			[errorCodes.dependsOnItself]: 'O literal depende dele mesmo',
			[errorCodes.invalidExpression]: 'Expressão inválida',
			[errorCodes.isNotAssignment]: 'A expressão precisa ser uma definição de símbolo, como em "A = 10"'
		};

		return messageByCode[code];
	}

	function input_input_handler() {
		rawInput = this.value;
		(((($$invalidate(0, rawInput), $$invalidate(1, unsaved)), $$invalidate(5, current)), $$invalidate(6, lastStringified)), $$invalidate(7, $userStore));
	}

	$$self.$$set = $$props => {
		if ('clearOnFinish' in $$props) $$invalidate(4, clearOnFinish = $$props.clearOnFinish);
		if ('current' in $$props) $$invalidate(5, current = $$props.current);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*unsaved, current, lastStringified, $userStore, rawInput*/ 227) {
			$: {
				if (!unsaved && current && current.stringified !== lastStringified) {
					$$invalidate(0, rawInput = addLocalization(current.stringified, $userStore));
					$$invalidate(6, lastStringified = rawInput);
				}
			}
		}
	};

	return [
		rawInput,
		unsaved,
		error,
		parseIfIsEnter,
		clearOnFinish,
		current,
		lastStringified,
		$userStore,
		input_input_handler
	];
}

class ExpressionParser extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { clearOnFinish: 4, current: 5 });
	}
}

export default ExpressionParser;